// biome-ignore lint/correctness/noUnusedImports: required
import React from 'react'
import { view } from 'react-easy-state'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import useNotifications from '../hooks/notifications'
import colors from '../settings/colors'
import globalState from '../state'

const Notifications = () => {
  const { cancelAutoremove, removeNotification } = useNotifications()

  return (
    <TransitionGroup
      className="pointer-events-none fixed top-0 w-full p-2"
      id="notifications"
    >
      {globalState.notifications.map(({ id, payload, type }) => (
        <CSSTransition classNames="transition" key={id} timeout={250}>
          {/** biome-ignore lint/a11y/noStaticElementInteractions: intended */}
          {/** biome-ignore lint/a11y/useKeyWithMouseEvents: intended */}
          <div
            className={`w-full border sm:w-1/2 lg:w-1/3 ${colors[type].fg} ${colors[type].bg} ${colors[type].border} ${colors[type].focus} ${colors[type].hover}rounded pointer-events-auto mb-2 ml-auto px-4 py-2 shadow-xl`}
            key={id}
            onTouchStart={() => cancelAutoremove(id)}
            onMouseOver={() => cancelAutoremove(id)}
          >
            <button
              className="ml-auto block hover:text-gray-300"
              onClick={() => removeNotification(id)}
              type="button"
            >
              <span
                aria-label="acknowledge"
                role="img"
                style={{
                  filter: 'grayscale(1) brightness(5)'
                }}
              >
                ❌
              </span>
            </button>
            <p>{payload}</p>
          </div>
        </CSSTransition>
      ))}
    </TransitionGroup>
  )
}

export default view(Notifications)
